module.exports = __webpack_public_path__ + "media/images/gallery/12s-a69cfe161cfc90ec84bde8521120c466.jpg";